import {
  Component,
  OnInit,
  ChangeDetectorRef,
  Input,
  Output,
  EventEmitter,
  HostListener,
  SimpleChanges
} from '@angular/core';
import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import {
  AppDataService,
  AvailableDocument,
  StepResponse,
  StepsService,
  GlobalVariablesService,
  UploadFileService,
  UploadDocRequest,
  StepRequest,
  DocumentService,
  DocumentsResponse
} from '@tmhcc-ng-lib/data-service';
import {
  DialogConfig,
  DialogFlag,
  DialogService
} from '@tmhcc-ng-lib/framwork/dialog';
import { UCMDialogComponent } from '../../ucm-forms/ucm-dialog/ucm-dialog.component';
import {
  CustomService,
  Types,
  ColumnDefinition,
  GridOptions
} from '@tmhcc-ng-lib/framwork/grid';
import { has } from 'libs/util/has-value';
import { IsTrue } from 'libs/util/binary-util';
import Responsive from 'datatables.net-responsive';
import { Global } from 'apps/artisan/src/global';
import { ButtonType, Messages, Status } from '@tmhcc-ng-lib/models';
import { AlertTosterService } from '@tmhcc/framwork/alert-toster';
import { DownloadDocumentRequest } from 'libs/data-service/def/document';

@Component({
  selector: 'ae-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss']
})
export class SharedDocumentsComponent implements OnInit {
  //@Input() dtOptions: DataTables.Settings = {};

  @Input() gridName: string;
  @Input() siteCoreData: any;
  @Input() actionItems: StepResponse;
  @Input() gridSetting: GridOptions;
  @Input() columnSettings: ColumnDefinition[];
  @Input() pageName: string;
  @Input() documentsData: DocumentsResponse;

  @Output() fillOutFormSubmitted = new EventEmitter<any>();
  @Output() handleFileInputChanged = new EventEmitter<any>();
  @Output() removeDocChanged = new EventEmitter<any>();
  @Output() dirtyCheckEvent = new EventEmitter<boolean>();

  fileToUpload: File = null;
  fileReUpload: File = null;
  pendingFileUpload: File = null;
  appFileUpload: File = null;
  columnMaps: ColumnDefinition[];
  linkData: any;
  viewData: any;
  dtOptions: DataTables.Settings = {};
  mobileView: boolean;
  selectedFile: File;
  tableData = [];
  uploadBtnFlag: boolean = true;
  isDocumentAvailable = false;
  // isUploadFile: boolean = false;

  constructor(
    private cdref: ChangeDetectorRef,
    private dialogConfig: DialogConfig,
    private dialogService: DialogService,
    private customService: CustomService,
    private globalVariablesService: GlobalVariablesService,
    private uploadFileService: UploadFileService,
    private alertService: AlertTosterService,
    private stepsService: StepsService,
    private loaderService: LoaderService,
    private documentService: DocumentService,
    private appDataService: AppDataService
  ) {}

  ngOnInit(): void {
    this.appDataService.getPolicyDetails().subscribe(res => {
      // if (res) {
      //   this.actionItems = res;
      //   //this.updatedTableData();
      //   this.loaderService.hide();
      // }
      this.loaderService.hide();
    });
    this.appDataService.getDocumentsDetail().subscribe(res => {
      if (res) {
        this.documentsData = res;
        this.updatedTableData();
        this.loaderService.hide();
       
      }
    });
  }
  ngOnChanges(simpleChange: SimpleChanges): void {
    if (this.gridSetting) {
      if (
        this.gridSetting.hasOwnProperty('isPersist') &&
        this.gridSetting.isPersist == true
      ) {
        this.dtOptions = this.customService.setGridDataOptionsForVisibility(
          this.gridSetting,
          'gridListContainer'
        );
      } else {
        this.dtOptions = this.customService.setGridDataOptions(
          this.gridSetting
        );
      }
    }
    if (this.columnSettings) {
      // when settings provided
      this.setCustomData(this.columnSettings);
      //  this.columnMaps = this.columnSettings;
    }
    //this.dtOptions.responsive = true;
    this.dtOptions.responsive = {
      details: {
        renderer: Responsive.renderer.listHiddenNodes()
      }
    };
    // this.updatedTableData();

    if (simpleChange.documentsData && this.documentsData && this.tableData) {
      this.tableData = this.tableData.map(items => {
        return {
          ...items,
          uploaded: false,
          downloaded: false
          //fName: items.FileName?.Name
        };
      });
    }
  }

  updatedTableData() {
    switch (this.pageName) {
      case 'documents':
        this.tableData = this.documentsData?.Documents;
        break;
      default:
        this.tableData = this.documentsData?.RequiredDocuments;
    }
    this.isDocumentAvailable = this.tableData && this.tableData.length > 0;
  }
  ngAfterViewInit() {
    if (window.innerWidth <= 768) {
      this.mobileView = true;
    } else {
      this.mobileView = false;
    }
    this.dtOptions.columnDefs = [
      {
        targets: [0],
        orderable: false,
        className: 'noVis',
        orderData: []
      }
    ];
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    event.target.innerWidth;
    if (event.target.innerWidth <= 768) {
      this.mobileView = true;
    } else {
      this.mobileView = false;
    }
  }

  handleFileInput(files: FileList, status: string, index) {
    const selectedFile = files.item(0);

    let maxSize = 6 * 1024 * 1024; // 6 MB;

    if (selectedFile.size > maxSize) {
      this.alertService.error(
        'Maximum size allowed is 6 MB',
        null,
        'toast-top-right',
        5000
      );
      return false;
    }
    this.selectedFile = selectedFile;
    this.tableData[index].uploaded = true;
    //this.tableData[index].fName = selectedFile.name;
    this.tableData = [...this.tableData];
    this.dirtyCheckEvent.emit(true);
  }
  removeDoc(index: number) {
    this.selectedFile = null;
    this.tableData[index].uploaded = false;
    //this.tableData[index].fName = this.tableData[index].FileName?.Name;
    this.tableData = [...this.tableData];
  }

  async upload(gridData, index, btnType) {
    this.loaderService.show();
    // this.isUploadFile = true;
    const base64 = await this.globalVariablesService.toBase64(
      this.selectedFile
    );

    const payload: UploadDocRequest = {
      PolicyId: btnType.PolicyId,
      VersionNum: btnType.VersionNum,
      FormType: btnType.FormType,
      DocTypeName: btnType.DocTypeName,
      FormName: btnType.FormName,
      FolderType: btnType.FolderType,
      FileName: btnType.FileName,
      PdfData: (<string>base64).split(',')[1]
    };
    this.uploadBtnFlag = false;
    this.uploadFileService.uploadDocument(payload).subscribe(
      res => {
        this.loaderService.show();
        if (res.Status == 'SUCCESS') {
            //Global.refreshData = 'true';
          this.alertService.success('Document Uploaded Successfully');
          this.uploadBtnFlag = true;
          this.tableData[index].uploaded = false;
          this.tableData[index].downloaded = false;
          this.selectedFile = null;
          this.dirtyCheckEvent.emit(false);
          //this.callPolicy();
          let payload: StepRequest = {
            policyId: this.globalVariablesService.policyId,
            versionNum: this.globalVariablesService.policyVersionId
          };
          if (
            this.globalVariablesService.policyId &&
            this.globalVariablesService.policyId > 0
          ) {
            this.appDataService.fetchAndPublishPolicyDetails(payload);
            this.appDataService.fetchAndPublishDocumentsDetail(payload);
          }
          else{
            this.loaderService.hide();
          }

        } else {
          this.loaderService.hide();
          this.uploadBtnFlag = true;
        }
      },
      error => {
        this.loaderService.hide();
        this.uploadBtnFlag = true;
        //throw error;
        this.alertService.error('File Upload Failed.');
      }
    );
  }
  fillOutForm(items: AvailableDocument, btn: any) {
    if (
      btn.ButtonType === ButtonType.FilloutForm ||
      btn.ButtonType === ButtonType.EditForm ||
      btn.ButtonType === ButtonType.Continue ||
      btn.ButtonType === ButtonType.ReSend
    ) {
      const formID =
        btn.ButtonType === ButtonType.Continue ||
        btn.ButtonType === ButtonType.ReSend
          ? btn.UCMFormId
            ? btn.UCMFormId
            : '6199'
          : btn.UCMFormId;

      this.dialogConfig.data = {
        formID: formID
      };

      this.dialogConfig.modalSetting = {
        title: Messages.SurplusLineHeading,
        hideHeader: false,
        hideFooter: true,
        hideSave: true,
        hideHeaderX: false
      };
      const ref = this.dialogService.open(
        UCMDialogComponent,
        this.dialogConfig
      );
      ref.afterClosed.subscribe(result => {
        if (result) {
          if (result === DialogFlag.ReloadRequired) {
            this.loaderService.show();
            this.refreshPolicyDetails();
          }
          this.cdref.detectChanges();
          this.fillOutFormSubmitted.emit(result);
        }
      });
    }
  }
  downloadApp(doc: any, btn: any, index) {
    this.tableData[index].downloaded = true;
    if (btn.FileURL) {
      this.documentService.openDocumentByUrl(btn.FileURL);
      return;
    }
    this.downloadPdfFile(btn,doc?.Form?.Name);
  }
  refreshPolicyDetails() {
    let payload: StepRequest = {
      policyId: this.globalVariablesService.policyId,
      versionNum: this.globalVariablesService.policyVersionId
    };
    //this.appDataService.fetchAndPublishPolicyDetails(payload);
    this.appDataService.fetchAndPublishDocumentsDetail(payload);
  }
  setCustomData(fields) {
    this.columnMaps = [];
    fields.forEach(element => {
      if (element.columnType === Types.link) {
        if (has(element, 'alignment')) {
          element.alignItem = 'text-right';
        } else {
          element.alignItem = 'text-left';
        }
        this.linkData = element;
      } else if (element.columnType === Types.view) {
        this.viewData = element;
      } else {
        if (element.columnType === Types.currency) {
          element.alignItem = 'text-right';
        } else {
          element.alignItem = 'text-left';
        }
        this.columnMaps.push(element);
      }
    });
  }

  isLinkAvailable(items) {
    if (has(items, 'Form.FileURL')) return true;
    return false;
  }
  isApiPathAvailable(items) {
    return has(items, 'FileName.ApiPath');
  }

  checkStatusReviewDoc(uploaded: boolean): boolean {
    const pages = [Status.Bound],
      statuses = [Status.EHelpReviewDoc],
      apiStatus = this.documentsData?.SummaryDetails.SummaryBoundItem
        .PolicyStatus;
    if (!uploaded && statuses.includes(apiStatus as Status)) {
      return !pages.includes(this.pageName as Status);
    } else if (!uploaded && !statuses.includes(apiStatus as Status)) {
      return true;
    }
    return !uploaded;
  }

  downloadPdfFile(doc: AvailableDocument,docName: string) {
    this.loaderService.show();
    let endpoint = this.documentService.generateEndpoint(
      doc,
      this.globalVariablesService.policyId,
      this.globalVariablesService.policyVersionId      
    );
    let payload = this.documentService.generatePayload(
      doc,
      this.globalVariablesService.policyId,
      this.globalVariablesService.policyVersionId,
      docName
    );
    this.documentService.downloadPdfData(endpoint,payload).subscribe(base64 => {
      this.documentService.openBase64NewTab(base64.Pdf);
      this.refreshPolicyDetails();
      //this.loaderService.hide();
    });
  }

  isFileUploadAction(btnType: any) {
    let validate =
      btnType.ButtonType !== ButtonType.FilloutForm &&
      btnType.ButtonType !== ButtonType.EditForm &&
      btnType.ButtonType !== ButtonType.Continue &&
      btnType.ButtonType !== ButtonType.ReSend &&
      btnType.ButtonType !== ButtonType.Download &&
      btnType.ButtonType !== ButtonType.ReDownload;
    return validate;
  }

  isFilloutFormAction(btnType: any) {
    let validate =
      (btnType.ButtonType != ButtonType.Download &&
        btnType.ButtonType != ButtonType.ReDownload) ||
      btnType.ButtonType === ButtonType.FilloutForm ||
      btnType.ButtonType === ButtonType.EditForm ||
      btnType.ButtonType === ButtonType.Continue ||
      btnType.ButtonType === ButtonType.ReSend;
    return validate;
  }

  isDownloadAction(btnType: any) {
    let validate =
      btnType.ButtonType == ButtonType.Download ||
      btnType.ButtonType == ButtonType.ReDownload;

    return validate;
  }
}
